import * as rudderanalytics from "rudder-sdk-js"
import MetricsProvider from "./MetricsProvider";

export default class Rudderstack extends MetricsProvider {
  constructor(appId, url) {
    super();
    this.appId = appId;
    this.url = url;
  }

  identify(userIdentity, userProps) {
    rudderanalytics.reset();
    rudderanalytics.identify(userIdentity, userProps);
  }

  recordEvent(name, properties) {
    rudderanalytics.track(name, properties);
  }

  install = () => {
    rudderanalytics.ready(() => {
      console.log("rudder stack loaded and ready")
    })
    rudderanalytics.load(this.appId, this.url, {loadIntegration:  false});
  }
}
